import axios from 'axios'

export const getFunds = ({ commit, state }, { force = false } = {}) => {
  if (state.loaded && !force) return Promise.resolve(state.funds)
  if (state.loading) return Promise.resolve(state.funds)

  commit('setLoading', true)
  return axios.get('/api/funds/listSimple')
    .then(response => {
      const data = (response.data && response.data.data) ? response.data.data : []
      commit('setFunds', data)
      return data
    })
    .catch(e => {
      console.error('funds/getFunds:', e)
      commit('setFunds', [])
      return []
    })
    .finally(() => {
      commit('setLoading', false)
    })
}
